import {
  handleDeleteRequest,
  handleGetRequest,
  handlePatchRequest,
  handlePostRequest
} from "../hooks/api";

/* ---------------------- Fetch events -------------------------------*/
// Service to handle location related requests. No need for error handling as it will be caught with outer component which calls this
export const fetchCommunityEvents = async (filters = {}) => {
  const { page = 1, limit = 10, ...otherFilters } = filters;

  const events = await handlePostRequest(
    "/events/getCommunityEvents",
    {
      ...otherFilters,
      page,
      limit
    },
    {},
    false
  );
  return events;
};

export const getPersonalEvents = async () => {
  const events = await handleGetRequest("/events/getPersonalEvents", undefined);
  if (events?.error) {
    throw new Error(events.error);
  }
  return events;
};

export const fetchCommercialEvents = async (filters = {}) => {
  const { page = 1, limit = 10, ...otherFilters } = filters;

  let endpoint = "/events/getCommercialEvents";
  const events = await handlePostRequest(
    endpoint,
    {
      ...otherFilters,
      page,
      limit
    },
    {},
    false
  );

  if (events?.error) {
    throw new Error(events.error);
  }
  return events;
};

/* ---------------------- Fetch events -------------------------------*/

/* ---------------------- Add events -------------------------------*/
export const addCommunityEvents = async payload => {
  const response = await handlePostRequest(
    "/events/addCommunityWeb",
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const addPersonalEvents = async payload => {
  const response = await handlePostRequest(
    "/events/addPersonalEvent",
    payload,
    undefined,
    true
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const addCommercialEvents = async payload => {
  const response = await handlePostRequest(
    "/events/addCommercialEvent",
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

/* ---------------------- Add events End-------------------------------*/

/* ---------------------- Fetch events By Id-------------------------------*/
export const fetchCommunityEventById = async id => {
  const events = await handleGetRequest(
    `/events/getCommunityEventbyId/${id}`,
    {}
  );
  if (events?.error) {
    throw new Error(events.error);
  }

  return events;
};

export const fetchPersonalEventById = async id => {
  const events = await handleGetRequest(
    `/events/getPersonalEventbyId/${id}`,
    {}
  );
  if (events?.error) {
    throw new Error(events.error);
  }

  return events;
};

export const fetchCommercialEventById = async id => {
  const events = await handleGetRequest(
    `/events/getCommercialEventbyId/${id}`,
    {}
  );
  if (events?.error) {
    throw new Error(events.error);
  }

  return events;
};

/* ---------------------- Fetch events By Id-------------------------------*/

/* ---------------------- Delete events -------------------------------*/
export const deleteCommunityEvent = async id => {
  const response = await handleDeleteRequest(
    `/events/deleteCommunityEvent/${id}`,
    undefined
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const deletePersonalEvent = async id => {
  const response = await handleDeleteRequest(
    `/events/deletePersonalEvent/${id}`,
    undefined
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const deleteCommercialEvent = async id => {
  const response = await handleDeleteRequest(
    `/events/deleteCommercialEvent/${id}`,
    undefined
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

/* ---------------------- Delete events End-------------------------------*/

/* ---------------------- Update events -------------------------------*/
/*
export const updateCommunityEvent = async id => {
  const response = await handlePatchRequest(
    `/events/updateCommercialEvent/${id}`,
    payload
  );

  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};
*/

// id is provided in payload
export const updatePersonalEvent = async payload => {
  const response = await handlePostRequest(`/events/updateEvent`, payload);

  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const updateCommercialEvent = async (id, payload) => {
  const response = await handlePatchRequest(
    `/events/updateCommercialEvent/${id}`,
    payload
  );

  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};
export const updateCommunityEvent = async (id, payload) => {
  const response = await handlePatchRequest(
    `/events/updateCommunityEvent/${id}`,
    payload
  );

  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};
/* ---------------------- Update events End-------------------------------*/

/* ---------------------- Event Types -------------------------------*/
export const getEventTypes = async () => {
  const response = await handlePostRequest(
    "/eventtypes/getEventTypes",
    {},
    {},
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const getEventNeeds = async () => {
  const response = await handleGetRequest("/events/getEventNeeds");
  if (response?.error){
    throw new Error(response.error)
  }

  return response
};

export const getEventTypeById = async id => {
  const payload = { id: id };
  const response = await handlePostRequest(
    "/eventtypes/getEventTypebyId",
    payload,
    {},
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

export const getEventNeedsFromType = async id => {
  const payload = { eventtypeid: id };
  const response = await handlePostRequest(
    "/eventtypes/getEventTypeNeeds",
    payload,
    {},
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
};

// payload example: {"need" : ["Cake aking","Catering"]}
export const getBusinessByNeeds = async payload => {
  const actualPayload = { need: payload };
  const response = await handlePostRequest(
    "/business/getBusinessesByNeeds",
    actualPayload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
};
/* ---------------------- Event Types End-------------------------------*/
